<div class="rs-panel-big rs-bg-c2 clearfix">
  <h2 class="rs-tit3">{{ 'publicWifi.pxsplus.configuration.select' | translate }}</h2>
  <p class="rs-status rs-status-ok">
    <i class="rs-status-icon" aria-hidden="true"></i
    >{{ 'publicWifi.pxsplus.configuration.configured' | translate }}
  </p>
  <!-- <p>{{ 'publicWifi.pxsplus.configuration.product_below' | translate }}</p> -->
  <div class="rs-entrypoint-container">
    <div class="rs-flex-row" role="list">
      <div class="rs-flex-columns small-12 medium-6" role="listitem">
        <a disabled href="#" class="rs-entrypoint">
          <i class="icon-Smartphone icon-lh rs-entrypoint-icon" aria-hidden="true"></i>
          <span class="rs-entrypoint-title">{{
            'publicWifi.pxsplus.configuration.device_configured' | translate
          }}</span>
          <!-- <span class="rs-entrypoint-arrow" aria-hidden="true"></span> -->
        </a>
      </div>
    </div>
  </div>
</div>
